import Vue from 'vue'
import App from './App.vue';
import router from './router';
import store from './store';
import * as filters from './filters';
import './assets/css/base.css';
import 'lib-flexible/flexible';
import VueCookies from "vue-cookies";
import $ from 'jquery';
import md5 from 'js-md5';
import utils from './utils/util';
import Service from './common/axios-config';
Vue.use(VueCookies);
Vue.config.productionTip = false;
// 全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
// 全局工具
Vue.prototype.$ = $;
Vue.prototype.$md5 = md5;
window.utils = Vue.prototype.utils = utils;
window.$http = Vue.prototype.$http = Service;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
